import { Flex, Layout } from "antd";
import { FC } from "react";
import {
    AssignmentResponseType,
    Point,
    TaskAssignment,
    TaskStatus,
} from "tm-shared/types";

import { ASSIGNMENT_VOCABULARY } from "@/constants/ui/assignment";
import { AssignmentTaskInfo } from "@/domains/assignment";
import {
    CustomTaskFromTaskButton,
    SubtaskCard,
    TaskViewModal,
} from "@/features/TaskView/components";

interface AssignmentViewModalProps {
    point: Point;
    task: TaskAssignment;
    onClose: () => void;
}

export const AssignmentViewModal: FC<AssignmentViewModalProps> = ({
    point,
    task,
    onClose,
}) => {
    const taskPayload = task.payload;
    const completedAt = task?.completedAt;

    if (!taskPayload || !completedAt) return null;

    const assignmentType = task.context.additionalData.assignmentType;
    const assignmentLabel = ASSIGNMENT_VOCABULARY[assignmentType]?.label;
    const taskImages = [
        ...(task?.context?.files?.length ? task.context.files : []),
        ...(taskPayload?.photos?.length ? taskPayload.photos : []),
    ];

    let title;

    if (task.context.responseType === AssignmentResponseType.Bool) {
        title = `Результат виконання: ${
            taskPayload.status === TaskStatus.Completed ? "Так" : "Ні"
        }`;
    }

    return (
        <TaskViewModal title={task.name} onClose={onClose} taskInfo={task.info}>
            <Flex vertical gap={16}>
                <CustomTaskFromTaskButton
                    task={task}
                    point={point}
                    images={taskImages}
                />
                <Layout style={{ padding: 16, borderRadius: 8 }}>
                    <AssignmentTaskInfo
                        assignmentType={assignmentLabel}
                        description={task.context.description}
                        images={task.context.files}
                    />
                </Layout>

                <SubtaskCard subtask={taskPayload} title={title} />
            </Flex>
        </TaskViewModal>
    );
};
